<template>
  <div class="page">
    <div class="bg"></div>
    <div class="footer">
      <div class="font-common font-gray tip">
        抱歉，班级测评支持小学语数英三科，您暂无权限访问该页面，
        {{ secondsToGo }}
        秒后将自动跳转到主页！
      </div>
      <div class="btn">
        <a-button type="primary" @click="backToHome">返回首页</a-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.page {
  background-color: #fff;
  height: 100vh;
  padding-top: 100px;
  .bg {
    position: relative;
    margin: 0 auto;
    width: 404px;
    height: 304px;
    background-image: url('https://cdn-cnc.17zuoye.cn/fs-resource/608131f13cb75e332771878d.png');
  }
  .footer {
    margin: 0 auto;
    .tip {
      margin: 16px auto;
      width: 100%;
      text-align: center;
    }
    .btn {
      width: 100%;
      text-align: center;
      margin: 0 auto;
      bottom: 50px;
      width: 100%;
    }
  }
}
</style>
<script>
let interval = null
export default {
  name: 'noclazzpermission',
  data() {
    return {
      secondsToGo: 5
    }
  },
  methods: {
    backToHome() {
      location.href = '/'
    },
    countDown() {
      interval = setInterval(() => {
        this.secondsToGo -= 1
        if (this.secondsToGo === 0) {
          clearInterval(interval)
          this.backToHome()
        }
      }, 1000)
    }
  },
  mounted() {
    this.countDown()
  },
  beforeDestroy() {
    clearInterval(interval)
  }
}
</script>
